import React, { CSSProperties, useState } from "react";
import { useDisplays } from "../../../services/displayservices/DisplayProvider";
import DisplayClock from "./DisplayClock";
import DisplayImage from "./DisplayImage";
import { ClockProvider } from "../../../services/ClockProvider";

interface Props {
  showInfo: boolean;
}

const DisplayInfo = ({ showInfo }: Props) => {
  const { display, getDisplays, getDisplayProperty } = useDisplays();
  const [showClock, setShowClock] = useState<boolean>(true);
  const getDisplayInfoStyle = (): CSSProperties => {
    let dispWid = getDisplayProperty("Width");
    let dispHei = getDisplayProperty("Height");

    let cs: CSSProperties = {
      fontSize: getDisplayProperty("FontSizeAdver") + "px",
      opacity: showInfo ? "0" : "1",
      position: "absolute",
      transition: "1s opaicty",
    };
    return cs;
  };
  return (
    <ClockProvider>
      <div style={getDisplayInfoStyle()}>
        {showClock ? <DisplayClock /> : <DisplayImage />}
      </div>
    </ClockProvider>
  );
};

export default DisplayInfo;
